import * as React from 'react'
import { Button, Icon } from '@atoms'
import { Dropdown } from '../../Dropdown/Dropdown'
import { useDropdownClickOutside } from '../../Dropdown/useDropdownClickOutside'

type DataSummaryProps = {
    showSummaryDropdown: boolean
    label: string
    disabled?: boolean
    buttonName?: string
    onDropdownVisibilityChange?: (isVisible: boolean) => void
    onDropdownHoverChange?: (isHovering: boolean) => void
    renderDropdownContent: (props: {
        onClose: () => void
        onMouseEnter: () => void
        onMouseLeave: () => void
    }) => React.ReactNode
}

export const DataSummary: React.FC<DataSummaryProps> = ({
    showSummaryDropdown,
    label,
    disabled = false,
    buttonName = 'summary-dropdown',
    onDropdownVisibilityChange,
    onDropdownHoverChange,
    renderDropdownContent,
}) => {
    const [isOpen, setIsOpen] = React.useState(false)
    const { buttonRef, dropdownRef } = useDropdownClickOutside(() => {
        if (isOpen) {
            setIsOpen(false)
        }
    })

    const toggle = () => {
        setIsOpen((prev) => {
            const newValue = !prev
            onDropdownVisibilityChange?.(newValue)
            return newValue
        })
    }

    if (!showSummaryDropdown) {
        return null
    }

    return (
        <Dropdown
            name={buttonName}
            buttonProps={{
                disabled,
                variant: 'outlineSecondary',
                size: 'medium',
                name: `${buttonName}-button`,
                children: (
                    <>
                        <Icon size="small" name="notes" />
                        {label}
                    </>
                ),
                buttonRef: buttonRef,
                'data-walkthrough': 'summary-dropdown',
            }}
            buttonComponent={Button}
            horizontalAlign="right"
            dropdownClassname="py-3 !min-w-[auto] w-max z-[50]"
            data-testid="summary-dropdown"
            isOpen={isOpen}
            onClick={toggle}
            dropdownRef={dropdownRef}
        >
            {renderDropdownContent({
                onClose: () => {
                    setIsOpen(false)
                    onDropdownVisibilityChange?.(false)
                    onDropdownHoverChange?.(false)
                },
                onMouseEnter: () => {
                    onDropdownHoverChange?.(true)
                },
                onMouseLeave: () => {
                    onDropdownHoverChange?.(false)
                },
            })}
        </Dropdown>
    )
}
